import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const titleMap = {
  "/Home": "Home",
  "/Dashboard": "Dashboard",
  "/Customer": "Customer Profile",
  "/Customers": "Customers Management",
  "/ServiceContract": "Service Contract",
  "/ServiceContractManagement": "Service Contract Management",
  "/CampaignManagement": "Campaign Management",
  "/CampaignDetail": "Campaign Detail",
  "/CampaignForm": "Campaign Form",
  "/AgentContact": "Agent Contact",

  "/Bookings": "Bookings",
  "/SaleInquiry": "Sales Inquiry",
  "/SalesOrderReport": "Sales Order Report",
  "/JobManagmentReport": "Job Managment Report",
  "/ReceiveReport": "Receive Report",
  "/OpenJobManagement": "OpenJob Management",
  "/SendInquiry": "Send Inquiry",
  "/SaleInquiryForm": "Sale Inquiry Form",

  "/SalesOrderManagement": "Sales Order Management",
  "/SaleInquiryDetail": "Sales Inquiry Detail",
  "/SaleActivity": "Sales Activity",
  "/SaleActivityForm": "Sales Activity Form",
  "/SaleActivityList": "Sales Activity List",

  "/QueueDetail": "Queue Detail",
  "/SalesOrderUserRole": "Sales Order User Role",
  "/SalesOrder": "SalesOrder",
  "/SalesOrderReportCarrier": "Sales Order Report Carrier",
  "/SalesOrderDetail": "Sales Order Detail",
  "/SalesOrderForm": "Sales Order Form",
  "/BookingConfirmation": "Booking Confirmation",
  "/JobManagment": "JobManagment",
  "/CostSheet": "CostSheet",
  "/Datamyne": "Datamyne",
  "/Register": "Register",
  "/profile": "profile",
  "/User": "User",

  // เพิ่ม route → title ตามต้องการ
};

export default function MenuTitle() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/[^/]+/, ""); // ลบ base url_path ถ้ามี
  const pageTitle = titleMap[path] || "S-CRM";

  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
}
